<template>
    <div class="project-nav">
        <div class="header-branding logo sidebar">
            <a href="/">
                <div v-if="clientLogo">
                    <img class='nav-logo' :src="clientLogo"/>
                </div>
                <div v-else>
                    <logo></logo>
                </div>
            </a>
        </div>
        <nav >
            <section class="nav-item" v-for="(navItem) in getNavItems" v-show="navItem.show" v-bind:key="navItem.name">
                <router-link :to="navItem.route" style="margin-top:15px">
                    <div class="c__vert--align">
                        <icon-calendar v-show="navItem.name=='Property Order'"></icon-calendar>
                        <icon-calendar v-show="navItem.name=='Agent Order'"></icon-calendar>
                        <icon-calendar v-show="navItem.name=='Office Order'"></icon-calendar>
                        <icon-clock v-show="navItem.name=='Campaigns'"></icon-clock>
                        <h2>{{ navItem.name }}</h2>
                    </div>
                </router-link>
            </section>
        </nav>
    </div>
</template>

<script>
    import logo from '../../assets/images/logo-acquire';
    import IconCalendar from '../../assets/icons/icon-calendar';
    import IconClock from '../../assets/icons/icon-clock';

    export default {
        name: "SideBar",
        props: ["agency"],
        components: {
            logo,
            IconCalendar,
            IconClock,
        },
        data () {
            return {
                navItems: [
                    {
                        name: 'Property Order',
                        route: '/office/' + this.agency.slug.name + '/property-campaigns/order',
                        show: true,
                    },
                    {
                        name: 'Agent Order',
                        route: '/office/' + this.agency.slug.name + '/agent-campaigns/order',
                        show: true,
                    },
                    {
                        name: 'Office Order',
                        route: '/office/' + this.agency.slug.name + '/office-campaigns/order',
                        show: true,
                    },
                    {
                        name: 'Campaigns',
                        route: '/office/' + this.agency.slug.name + '/campaigns',
                        show: true,
                    }
                ],
                clientLogo: null,
                subdomain: null
            }
        },
        computed: {
            getNavItems: function() {
                let user = this.$store.getters.getUser;
                if (user.role === 'ROLE_AGENT_USER') {
                    this.navItems[0].show = user.permissions.canViewMediaOrders;
                    this.navItems[1].show = user.permissions.canViewMediaOrders;
                    this.navItems[2].show = false;
                    this.navItems[3].show = user.permissions.canViewPastOrders;
                }
                return this.navItems
            }
        },
        mounted() {
            const favicon = document.getElementById("favicon");
            const faviconApple = document.getElementById("favicon-apple");
            let logoUrl = this.$store.state.logo;
            let logoInverse = this.$store.state.logoInverse;
            let faviconUrl = this.$store.state.favicon;
            this.clientLogo = logoInverse ? logoInverse : logoUrl ? logoUrl : null;
            if (faviconUrl) {
                favicon.href = faviconUrl;
                faviconApple.href = faviconUrl;
            }
        }
    }
</script>

<style scoped>


</style>
